import { FaRegCircleCheck } from 'react-icons/fa6';
import { TbLocation } from 'react-icons/tb';
import { useEffect, useState } from 'react';
// components
import Gallery from '../Gallery/Gallery';
// style
import style from './playground.module.css';

const Playground = ({ id }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch data from playground
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/api/1');
        const result = await response.json();
        setData(result);
      } catch (err) {
        setError('Ошибка загрузки данных');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Filter item based on id
  const item = data.find((item) => item.seo_url == id);

  if (loading) {
    return (
      <section className={style.playground}>
        <div className={style.error}>
          <div className="loader"></div>
        </div>
      </section>
    );
  }

  if (error || !item) {
    return (
      <section className={style.playground}>
        <div className={style.error}>
          Ошибка: {error || 'Данные не найдены'}
        </div>
      </section>
    );
  }

  return (
    <section className={style.playground}>
      <div className="container">
        <div className={style.top} key={item.id}>
          {/* Left content */}
          <div className={style.left}>
            <div className="title">
              <h2 className={style.before}>{item.Name}</h2>
              <p className={style.text}>{item.Description}</p>
            </div>
            <div className={style.desc}>
              <ul>
                {item.Quanty && (
                  <li>
                    <FaRegCircleCheck className={style.icon} />
                    <span>{item.Quanty}</span>
                  </li>
                )}
                {item.Relax && (
                  <li>
                    <FaRegCircleCheck className={style.icon} />
                    <span>{item.Relax}</span>
                  </li>
                )}
                {item.Loc && (
                  <li>
                    <FaRegCircleCheck className={style.icon} />
                    <span>{item.Loc}</span>
                  </li>
                )}
                {item.Parking && (
                  <li>
                    <FaRegCircleCheck className={style.icon} />
                    <span>{item.Parking}</span>
                  </li>
                )}
              </ul>
              {item.mapImg && (
                <div className={style.map}>
                  <img
                    src={`../imgs/playground/${item.mapImg}`}
                    alt="Playground map"
                  />
                  <div className={style.map_btn}>
                    <a
                      href={item.Url_address}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Открыть на карте
                      <TbLocation className={style.mapIcon} />
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* Right content */}
          <div className={style.right}>
            <Gallery item={item} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Playground;
